// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAllowContributionsOverElectionAmountDto
 */
export interface IAllowContributionsOverElectionAmountDto {
    /**
     * 
     * @type {boolean}
     * @memberof IAllowContributionsOverElectionAmountDto
     */
    is_allow_contributions_over_election_amount?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAllowContributionsOverElectionAmountDto
     */
    is_allow_contributions_over_election_amount_state?: IAllowContributionsOverElectionAmountDtoIsAllowContributionsOverElectionAmountStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAllowContributionsOverElectionAmountDtoIsAllowContributionsOverElectionAmountStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAllowContributionsOverElectionAmountDto interface.
 */
export function instanceOfIAllowContributionsOverElectionAmountDto(value: object): value is IAllowContributionsOverElectionAmountDto {
    return true;
}

export function IAllowContributionsOverElectionAmountDtoFromJSON(json: any): IAllowContributionsOverElectionAmountDto {
    return IAllowContributionsOverElectionAmountDtoFromJSONTyped(json, false);
}

export function IAllowContributionsOverElectionAmountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowContributionsOverElectionAmountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_allow_contributions_over_election_amount': json['is_allow_contributions_over_election_amount'] == null ? undefined : json['is_allow_contributions_over_election_amount'],
        'is_allow_contributions_over_election_amount_state': json['is_allow_contributions_over_election_amount_state'] == null ? undefined : json['is_allow_contributions_over_election_amount_state'],
    };
}

export function IAllowContributionsOverElectionAmountDtoToJSON(json: any): IAllowContributionsOverElectionAmountDto {
    return IAllowContributionsOverElectionAmountDtoToJSONTyped(json, false);
}

export function IAllowContributionsOverElectionAmountDtoToJSONTyped(value?: IAllowContributionsOverElectionAmountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_allow_contributions_over_election_amount': value['is_allow_contributions_over_election_amount'],
        'is_allow_contributions_over_election_amount_state': value['is_allow_contributions_over_election_amount_state'],
    };
}

